import React, {useState, useEffect, useRef, useMemo, useCallback} from 'react';
import { View, TouchableOpacity } from 'react-native'

import tw from '../../../../styles/tailwind';
import Text from '../../../../components/Text';
import Icon from '../../../../components/IcomoonIcon';
import Input from '../../../../components/Forms/Input';
import { useForm } from 'react-hook-form';
import IconButton from '../../../../components/IconButton';


import BottomSheet from '../../../../components/BottomSheet';
import useFormSubmit from '../../../../hooks/useFormSubmit';
import FilePicker from '../../../../components/FilePicker';


export default function NewDocumentModal({ onRequestClose, onDocumentCreated, visible, communityId }) {
  const { control, handleSubmit, setValue } = useForm();
  // const file = watch('file')


  const { submitForm, isSubmitting } = useFormSubmit({
    onSuccess: onDocumentCreated,
    onError: (error) => { },
    successToastMessage: "Documento creado",
    endpoint: `/communities/${communityId}/documents`,
  })


  return (
    <BottomSheet
      height={700}
      visible={visible}
      onRequestClose={onRequestClose}
      showCloseButton={true}
    >
      <View style={tw`px-5`}>
        <View style={tw`row justify-between mb-4 mt-5`}>
          <Text style={tw`text-lg font-600 text-secondary`}>Nuevo Documento</Text>

          <TouchableOpacity
            style={tw`items-center justify-center mr-2`}
            onPress={onRequestClose}
          >
            <Icon name='close' style={tw`text-red`} size={26} />
          </TouchableOpacity>
        </View>

        <View style={tw`mb-0`}>
          <Text style={tw`text-gray-500`}>Nombre</Text>
          <Input
            control={control}
            name='name'
            style={{ subcontainer: tw`rounded-lg` }}
            maxLength={100}
            rules={{required: true}}
          />
        </View>

        <View style={tw`mb-0`}>
          <Text style={tw`text-gray-500`}>Descripción</Text>
          <Input
            control={control}
            name='description'
            multiline
            numberOfLines={5}
            style={{ subcontainer: tw`rounded-lg`, input: {height: 120, textAlignVertical: 'top'} }}
            // rules={{required: true}}
          />
        </View>

        <View style={tw`mb-6`}>
          <FilePicker
            onFileSelected={file => {
              console.log("onfileselected", file)
              setValue('file_uid', file?.uuid)
            }}
            label="Seleccionar archivo"
            postUrl={`/communities/${communityId}/images`}
          />
        </View>

        <IconButton
          title={"Subir documento"}
          disabled={isSubmitting}
          style={tw`self-end`}
          onPress={handleSubmit(submitForm)}
        />
      </View>

    </BottomSheet>
  );
}
